export default function Creater() {
  return (
    <p className="creater">
      created by <a href="https://github.com/ishakson">ishak söylemez</a>
    </p>
  );
}
